export const BRAND_COLORS = {
  navy: "#011947",
  navyDark: "#000f30",
  navyLight: "#022d6b",
  gold: "#8D7339",
  goldDark: "#75602f",
  goldDarker: "#5f4e26",
};
